export const CHAT_GA4_MESSAGE_TYPE = "_CHAT_GA4";

export const CHAT_GA4_EVENTS = {
  LAUNCHER_CLICK: "launcher_click",
  LINK_VIEW: "link_view",
  LINK_CLICK: "link_click",
};

export function notifyParentChatGa4(event) {
  try {
    if (window.parent && window.parent !== window) {
      window.parent.postMessage({ type: CHAT_GA4_MESSAGE_TYPE, event }, "*");
    }
  } catch (_) {
    /* analytics must not break chat UX */
  }
}

export function isAcesseAquiAppLink(href, children) {
  const linkText = Array.isArray(children)
    ? children.join("")
    : typeof children === "string"
      ? children
      : "";
  const normalizedText = linkText.trim().toLowerCase();
  const hrefValue = (href || "").toLowerCase();

  if (normalizedText.includes("acesse aqui")) {
    return true;
  }

  return /go\.link|apps\.apple\.com|play\.google\.com/.test(hrefValue);
}

export function messageContainsAcesseAquiLink(text) {
  if (typeof text !== "string") {
    return false;
  }

  if (/\[([^\]]*acesse\s+aqui[^\]]*)\]\(([^)]+)\)/i.test(text)) {
    return true;
  }

  return (
    /acesse\s+aqui/i.test(text) &&
    /go\.link|apps\.apple\.com|play\.google\.com/i.test(text)
  );
}
